















































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import BrandsStore from "@/mixins/brandsStore";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IProductPricesIssueMessages, IPricelist } from "@/models/products";

@Component({
  computed: {
    ...mapState({
      priceLists(state, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule,
          scope: this.priceListsScope
        });
      },
      priceListsScope(state, getters) {
        return getters[`data/${this.dataModule}/priceListsScope`](this.brandId);
      }
    })
  }
})
export default class PriceIssueMessages extends Mixins(
  CurrenciesStore,
  BillingCyclesStore,
  BrandsStore
) {
  // State
  public priceLists!: IPricelist[];

  // Props
  @Prop({ required: true })
  public issueMessages!: IProductPricesIssueMessages[];

  @Prop({ default: false })
  public isClosable!: boolean;

  public dataModule: DataModules = DataModules.PRICELISTS;

  public getPriceListName(priceListId) {
    return this.$_.get(
      this.$_.find(this.priceLists, ["id", priceListId]),
      "name",
      ""
    );
  }

  public getType(issueMessage) {
    if (issueMessage.warnings.length && issueMessage.errors.length) {
      return this.$tc("_.messages", 2)
        .toString()
        .toLowerCase();
    }

    if (issueMessage.warnings.length) {
      return this.$tc("_.warnings", issueMessage.warnings.length)
        .toString()
        .toLowerCase();
    }

    return this.$tc("_.errors", issueMessage.errors.length)
      .toString()
      .toLowerCase();
  }

  public get hasAnyErrors() {
    return this.$_.find(this.issueMessages, issue => !!issue.errors.length);
  }

  public getWarningTermName(billingTerm) {
    if (billingTerm === 0) {
      return this.$t("_.one_time");
    }

    return this.$_.get(
      this.$_.find(this.billingCycles, ["months", billingTerm]),
      "name",
      this.$tc("_plurals.months", billingTerm)
    );
  }

  public getErrorsAndWarnings(issueMessage) {
    return _.concat(
      this.getMessages(issueMessage.errors),
      this.getMessages(issueMessage.warnings)
    );
  }

  public getMessages(issueMessages) {
    const messages: any = [];

    _.forEach(issueMessages, issueMessage => {
      const index = _.findIndex(
        messages,
        (messageObj: any) =>
          messageObj.message === issueMessage.message &&
          messageObj.billing_cycle_months === issueMessage.billing_cycle_months
      );

      if (index !== -1) {
        messages[index].currencies.push(issueMessage.currency_id);
      } else {
        messages.push(
          _.merge(
            _.pick(issueMessage, [
              "message",
              "billing_cycle_months",
              "isError"
            ]),
            { currencies: [issueMessage.currency_id] }
          )
        );
      }
    });

    return messages;
  }

  public getCurrencyCodes(currencies) {
    const count = currencies.length > 4 ? 3 : 4;

    const currenciesCodes = _.map(currencies.slice(0, count), currencyId => {
      return this.$_.get(
        this.$_.find(this.currencies, ["id", currencyId]),
        "code",
        ""
      );
    }).join(", ");

    return `(${currenciesCodes}${
      currencies.length > count
        ? ` + ${this.$tc("_plurals.more", currencies.length - count)}`
        : ""
    })`;
  }
}
